import { ChevronLeft } from 'lucide-react';
import React from 'react'
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  title: string;
  href: string;
}

const Header = ({title, href}: HeaderProps) => {

  const navigate = useNavigate();

  return (
    <div className='p-3 flex items-center justify-between border-b-2 border-gray-500'>
      <h1 className='font-medium text-2xl text-start'>{title}</h1>
      <button className='text-lg flex gap-1 items-center border border-gray-600 bg-slate-300 hover:gray-400 px-3 py-2 rounded-lg shadow-md hover:shadow-gray-600'
        onClick={() => navigate(href)}
      >
        <ChevronLeft />
        Back
      </button>
    </div>
  );
}

export default Header